// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1287":"9616e602","2811":"9616e602","3036":"ac82bcbc","4267":"ac82bcbc","4969":"f1640d23","6373":"ac82bcbc","6820":"f1640d23","8017":"9616e602"}[chunkId] + ".chunk.css";
};